import { useParams } from 'react-router-dom'

export const useOptionalWaveId = (): string | undefined => useParams().waveId
